import { Box } from '@fhs-legacy/universal-components';

const CartItemInfoContainer = Box.withConfig({
  padding: 4,
  justifyContent: 'space-between',
});

export default CartItemInfoContainer;
